import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getReportSetting, searchReportSetting } from '../../../redux/actions/reportSetting'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectIndicatorsWidget from '../../../widgets/projectIndicatorsWidgets/ProjectIndicatorsWidget'
import { getProjectIndicators } from '../../../redux/actions/projectIndicators'

export default function ProjectIndicators() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectIndicators()
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <ProjectIndicatorsWidget schema={schema} />
        </SidebarProposal>
      )}
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      header: null,
      searchForm: {
        header: null,
        year: {
          name: 'year',
          label: 'ปี',
          value: null,
        },
        startDate: {
          name: 'startDate',
          label: 'วันที่เริ่มต้น',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกวันที่เริ่มต้น',
            },
          ],
        },
        endDate: {
          name: 'endDate',
          label: 'วันที่สิ้นสุด',
          value: 0,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกวันที่สิ้นสุด',
            },
          ],
        },
        supTeamLeader: {
          name: 'supTeamLeader',
          label: 'หัวหน้าทีมสนับสนุน',
          value: null,
          options: [
            {
              disabled: false,
              label: 'หัวหน้าทีมสนับสนุน1',
              value: '0',
            },
            {
              disabled: false,
              label: 'หัวหน้าทีมสนับสนุน2',
              value: '1',
            },
          ],
        },
        supported: {
          name: 'Supported',
          label: 'ที่สนับสนุน',
          value: null,
          options: [
            {
              disabled: false,
              label: 'ที่สนับสนุน1',
              value: '0',
            },
            {
              disabled: false,
              label: 'ที่สนับสนุน2',
              value: '1',
            },
          ],
        },
        sector: {
          name: 'sector',
          label: 'ภาค',
          value: null,
          options: [
            {
              disabled: false,
              label: 'ภาค1',
              value: '0',
            },
            {
              disabled: false,
              label: 'ภาค2',
              value: '1',
            },
          ],
        },
        totalAmount: {
          name: 'totalAmount',
          label: 'จำนวนทั้งหมดจาก ',
          value: 110,
        },
        step: {
          current: 1,
          currentStatus: 'process',
          item: ['10 %', '20 %', '40 %', '60 %', '80 %', '100 %'],
          descriptions: [
            '60 โครงการ',
            '50 โครงการ',
            '40 โครงการ',
            '30 โครงการ',
            '20 โครงการ',
            '10 โครงการ',
          ],
        },
      },
      projectLists: [
        {
          title: 'ตัวชี้วัดโครงการ',
          indicatorsData: {
            beneficiaries: {
              name: 'beneficiaries',
              label: 'ผู้ได้รับผลประโยชน์',
              value: ' - ',
            },
            socialFactors: {
              name: 'socialFactors',
              label: 'โครงการที่เกิดสภาพแวดล้อมหรือปัจจัยทางสังคมที่เอื้อต่อสุขภาวะ',
              value: 240,
            },
            innovation: {
              name: 'innovation',
              label: 'นวัตกรรมฯ ระดับพื้นที่',
              value: 131,
            },
            straight: {
              name: 'straight',
              label: 'ทางตรง',
              value: 50759,
            },
            rules: {
              name: 'rules',
              label: 'กฏ กติกา มาตรการชุมชน',
              value: 114,
            },
            newKnowledge: {
              name: 'newKnowledge',
              label: 'พัฒนาความรู้ใหม่จากวิจัยพัฒนา',
              value: 9,
            },
            bypass: {
              name: 'bypass',
              label: 'ทางอ้อม',
              value: 82039,
            },
            structure: {
              name: 'structure',
              label: 'กลไก ระบบ โครงสร้าง',
              value: 73,
            },
            deploy: {
              name: 'deploy',
              label: 'นำสิ่งที่มีอยู่ในชุมชนอื่นมาปรับใช้ในชุมชนตนเอง',
              value: 75,
            },
          },
          isIcon: true,
          value: [
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'โครงการตัวอย่างดี',
              totalProject: '100',
              unitProject: 'โครงการ',
              totalBudget: null,
              buttonColor: '#9AB7D3',
            },
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'จำนวนแกนนำ',
              totalProject: '13',
              unitProject: 'คน',
              totalBudget: null,
              buttonColor: '#B5EAD6',
            },
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'จำนวนกลุ่มเป้าหมายเข้าร่วมโครงการ',
              totalProject: '100',
              unitProject: 'โครงการ',
              totalBudget: null,
              buttonColor: '#ffc489',
            },
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'จำนวนกลุ่มเป้าหมายปรับพฤติกรรม',
              totalProject: '100',
              unitProject: 'โครงการ',
              totalBudget: null,
              buttonColor: '#7dc5e9',
            },
          ],
        },
        {
          title: 'ความเสี่ยงโครงการ',
          indicatorsData: null,
          isIcon: false,
          value: [
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'ความเสี่ยงสูง',
              totalProject: '3',
              unitProject: 'โครงการ',
              totalBudget: null,
              buttonColor: '#fb8a81',
            },
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'ความเสี่ยงปานกลาง',
              totalProject: '32',
              unitProject: 'โครงการ',
              totalBudget: null,
              buttonColor: '#ffc489',
            },
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'ความเสี่ยงต่ำ',
              totalProject: '115',
              unitProject: 'โครงการ',
              totalBudget: null,
              buttonColor: '#7dc5e9',
            },
            {
              projectStatusCode: '',
              projectStatusName: '',
              displayName: 'ไม่มีความเสี่ยง',
              totalProject: '0',
              unitProject: 'โครงการ',
              totalBudget: null,
              buttonColor: '#B5EAD6',
            },
          ],
        },
      ],
    },
    header: 'ตัวชี้วัดโครงการ',
    subHeader: null,
    disabled: true,
    isApprover: false,
  },
}
